import axios from 'axios'
import { ErrorStateActions } from 'store/actionCreators'

let ip = null
if (process.env.REACT_APP_ENV === 'qa') {
  ip = 'https://apiqa.motiners.com/'
} else if (process.env.REACT_APP_ENV === 'dev') {
  ip = 'http://localhost:3001/'
} else {
  ip = 'https://api.motiners.com/'
}

const api = {
  getRequestData: (path, callBack = null) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get(`${ip}${path}`, {
          withCredentials: true,
        })

        if (callBack) {
          resolve(callBack(response.data))
        } else {
          resolve(response.data)
        }
      } catch (error) {
        if (error?.response?.status === 429) {
          ErrorStateActions.setTooManyReqErr({ tooManyReqTriggered: true })
        }

        let returnVal = null
        if (error?.response?.data) {
          returnVal = error.response.data
        }
        if (callBack) {
          resolve(callBack(returnVal))
        } else {
          resolve(returnVal)
        }
      }
    })
  },
  postRequestData: (path, body, callBack = null) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(`${ip}${path}`, body, {
          withCredentials: true,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        if (callBack) {
          resolve(callBack(response.data))
        } else {
          resolve(response.data)
        }
      } catch (error) {
        if (error?.response?.status === 429) {
          ErrorStateActions.setTooManyReqErr({ tooManyReqTriggered: true })
        }

        let returnVal = null
        if (error?.response?.data) {
          returnVal = error.response.data
        }

        if (callBack) {
          resolve(callBack(returnVal))
        } else {
          resolve(returnVal)
        }
      }
    })
  },
  putRequestData: (path, body, callBack = null) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.put(`${ip}${path}`, body, {
          withCredentials: true,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        if (callBack) {
          resolve(callBack(response.data))
        } else {
          resolve(response.data)
        }
      } catch (error) {
        if (error?.response?.status === 429) {
          ErrorStateActions.setTooManyReqErr({ tooManyReqTriggered: true })
        }

        let returnVal = null
        if (error?.response?.data) {
          returnVal = error.response.data
        }

        if (callBack) {
          resolve(callBack(returnVal))
        } else {
          resolve(returnVal)
        }
      }
    })
  },
  deleteRequestData: (path, body, callBack = null) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.delete(`${ip}${path}`, {
          data: body,
          withCredentials: true,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        if (callBack) {
          resolve(callBack(response.data))
        } else {
          resolve(response.data)
        }
      } catch (error) {
        if (error?.response?.status === 429) {
          ErrorStateActions.setTooManyReqErr({ tooManyReqTriggered: true })
        }

        let returnVal = null
        if (error?.response?.data) {
          returnVal = error.response.data
        }

        if (callBack) {
          resolve(callBack(returnVal))
        } else {
          resolve(returnVal)
        }
      }
    })
  },
  postRequestFormData: (path, body, callBack = null, options = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(`${ip}${path}`, body, {
          withCredentials: true,
          onUploadProgress: options?.onUploadProgress,
          onDownloadProgress: options?.onDownloadProgress,
        })
        if (callBack) {
          resolve(callBack(response.data))
        } else {
          resolve(response.data)
        }
      } catch (error) {
        if (error?.response?.status === 429) {
          ErrorStateActions.setTooManyReqErr({ tooManyReqTriggered: true })
        }

        let returnVal = null
        if (error?.response?.data) {
          returnVal = error.response.data
        }

        if (callBack) {
          resolve(callBack(returnVal))
        } else {
          resolve(returnVal)
        }
      }
    })
  },
  updateRequestFormData: (path, body, callBack = null) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(`${ip}${path}`, body, {
          withCredentials: true,
        })
        if (callBack) {
          resolve(callBack(response.data))
        } else {
          resolve(response.data)
        }
      } catch (error) {
        if (error?.response?.status === 429) {
          ErrorStateActions.setTooManyReqErr({ tooManyReqTriggered: true })
        }

        let returnVal = null
        if (error?.response?.data) {
          returnVal = error.response.data
        }

        if (callBack) {
          resolve(callBack(returnVal))
        } else {
          resolve(returnVal)
        }
      }
    })
  },
  deleteReqestFormData: (path, body, callBack = null) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.delete(`${ip}${path}`, {
          data: body,
          withCredentials: true,
        })
        if (callBack) {
          resolve(callBack(response.data))
        } else {
          resolve(response.data)
        }
      } catch (error) {
        if (error?.response?.status === 429) {
          ErrorStateActions.setTooManyReqErr({ tooManyReqTriggered: true })
        }

        let returnVal = null
        if (error?.response?.data) {
          returnVal = error.response.data
        }

        if (callBack) {
          resolve(callBack(returnVal))
        } else {
          resolve(returnVal)
        }
      }
    })
  },
  socialLoginRequest: (path, body, callBack) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(`${path}`, body, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        if (callBack) {
          resolve(callBack(response.data))
        } else {
          resolve(response.data)
        }
      } catch (error) {
        if (error?.response?.status === 429) {
          ErrorStateActions.setTooManyReqErr({ tooManyReqTriggered: true })
        }

        let returnVal = null
        if (error?.response?.data) {
          returnVal = error.response.data
        }

        if (callBack) {
          resolve(callBack(returnVal))
        } else {
          resolve(returnVal)
        }
      }
    })
  },
}

export default api
